// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconMedOpmiZoom_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M8 7.5L10.5 7.5L7 3L3.5 7.5H6L6 16.5H3.5L7 21L10.5 16.5H8L8 7.5Z" class="svg-bg"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M17.6066 8.53478C19.232 10.1602 19.5044 12.6263 18.4237 14.5334L20.7886 18.0807L20.0815 18.7878L16.5342 16.423C14.627 17.5036 12.1609 17.2313 10.5355 15.6058C8.58291 13.6532 8.58291 10.4874 10.5355 8.53478C12.4882 6.58216 15.654 6.58216 17.6066 8.53478ZM16.1924 14.1916C17.364 13.0201 17.364 11.1206 16.1924 9.94899C15.0208 8.77742 13.1213 8.77742 11.9497 9.94899C10.7782 11.1206 10.7782 13.0201 11.9497 14.1916C13.1213 15.3632 15.0208 15.3632 16.1924 14.1916Z" class="svg-bg"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M24 0H0V24H24V0ZM22 2H2V22H22V2Z" class="svg-bg"/>
</svg>
`;
/**
 * IconMedOpmiZoom is a generated icon component.
 */
let IconMedOpmiZoom = IconMedOpmiZoom_1 = class IconMedOpmiZoom extends IconBaseElement {
    render() {
        return html `${IconMedOpmiZoom_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconMedOpmiZoom.icons = new Map([
    ['s8', _s24IconSvg],
    ['s12', _s24IconSvg],
    ['s16', _s24IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s24IconSvg],
    ['s40', _s24IconSvg],
    ['s48', _s24IconSvg],
    ['s64', _s24IconSvg],
    ['s72', _s24IconSvg],
    ['s80', _s24IconSvg],
]);
IconMedOpmiZoom = IconMedOpmiZoom_1 = __decorate([
    customElement('zui-icon-med-opmi-zoom')
], IconMedOpmiZoom);
export { IconMedOpmiZoom };
